// services/components/strategies/common/CommandPalette/InputButton.tsx
'use client'
import React from 'react'
import Icon from '@/services/components/strategies/common/Icon'
import { UUID } from '@/utils/idGenerator'

export interface InputButtonProps {
  id?: string
  placeholder?: string
  onClick: () => void
}

const InputButton: React.FC<InputButtonProps> = ({
  id = UUID(),
  placeholder,
  onClick,
}) => {
  return (
    <div data-cy={`command-palette-${id}-input-button`}>
      <button
        type="button"
        onClick={onClick}
        className="flex px-5 border rounded-full border-grey-3 w-full hover:border-grey-2 shadow-none focus:shadow-none relative cursor-pointer bg-basic-white"
        aria-label="Suche"
      >
        <div
          className="pointer-events-none absolute left-2 top-[12px] flex items-center pl-3"
          data-cy={`command-palette-${id}-input-button-icon`}
        >
          <Icon name="search-1" size={20} />
        </div>
        <input
          type="button"
          className="border-none pl-8 focus:shadow-none py-4 placeholder:text-grey-1 placeholder:not-italic text-base w-32 xs:w-full bg-transparent px-2 h-[40px] cursor-pointer"
          placeholder={placeholder}
          aria-label={placeholder}
          data-cy={`command-palette-${id}-input-button-input`}
        />
        <div className="pointer-events-none absolute left-2 top-[12px] flex items-center text-base pl-10 text-grey-1 truncate">
          {placeholder}
        </div>
      </button>
    </div>
  )
}

export default InputButton
